import { render, staticRenderFns } from "./KPI.vue?vue&type=template&id=fef0a822"
import script from "./KPI.vue?vue&type=script&lang=js"
export * from "./KPI.vue?vue&type=script&lang=js"
import style0 from "./KPI.vue?vue&type=style&index=0&id=fef0a822&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports